export const draftHLISelected = (dataTableApi) => {
	const selectedIds =
		dataTableApi?.current?.rowSelectionManager?.tree?.children?.loadedNodes
			?.filter(({ selectionState }) => selectionState === true)
			?.map(({ renderProps }) => renderProps?.value) || [];
	const selectedRows = selectedIds?.map((id) => dataTableApi?.current?.dataProvider?.data?.find?.(({ UniqueID }) => UniqueID === id)) || [];
	// flter out any null or undefined rows that may exist in the selectedRows array due to the find operation not finding a match for previously deleted selectedIds
	const sanitizedSelectedRows = selectedRows?.filter((row) => row) || [];
	return sanitizedSelectedRows?.some((row) => row.IsDraft === "True") || false;
};
